import { customAxios, FDV_URL, IDUSUARIO } from '../constants';


export function fetchDesasignarPedidos(numero,numPedidoVeh,codCia,codProv,nurFichaVtaPedido,codMotivo,obserDesa,labelTipo,tipoDesasignacion) {

  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
    params: {

    },
  };

  const data = {
    numPedidoVeh,
    codCia:codCia,
    codProv:codProv,
    nurFichaVtaPedido:nurFichaVtaPedido,
    codMotivo,
    obserDesa,
    labelTipo,
    tipoDesasignacion
  }

    return customAxios.put(`${FDV_URL}/ficha-venta/fichas-venta/${numero}/pedidos`,data ,config);

}



// WEBPACK FOOTER //
// ./src/utils/DesasignacionPedido.js